import { render, staticRenderFns } from "./resources-input.vue?vue&type=template&id=3b8c0de2&"
import script from "./resources-input.vue?vue&type=script&lang=js&"
export * from "./resources-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports